import { i18n } from "@/main";
import moment from "moment";
import { LOCAL_STORAGE_KEYS } from "@/enums/local-storage";
import usersService from "@/services/users";
import serviceHandler from "@/helpers/handlers/service";
import { setCustomValidators } from "@/config/validators";

export default {
  async changeLanguage({ commit, getters }, payload) {
    i18n.locale = payload.locale;
    setCustomValidators(i18n);

    moment.locale(payload.locale);

    document.documentElement.lang = payload.locale;
    if (
      this.getters["auth/isAuthenticated"] &&
      this.getters["company/isWizardCompleted"]
    ) {
      await serviceHandler(
        usersService.patchUserDetails({
          language: payload.locale
        })
      );
    }
    localStorage.setItem(LOCAL_STORAGE_KEYS.LANGUAGE, JSON.stringify(payload));

    commit("CHANGE_LANGUAGE_HANDLER", payload.locale);
  },
  setLanguage({ commit }, payload) {
    const data = this.getters["settings/languages"].find(
      e => e.locale === payload
    );
    localStorage.setItem(LOCAL_STORAGE_KEYS.LANGUAGE, JSON.stringify(data));
    commit("CHANGE_LANGUAGE_HANDLER", data.locale);
  },
  setActiveMenuGroup({ commit }, payload) {
    commit("SET_ACTIVE_MENU_GROUP_HANDLER", payload);
  },
  openModal({ state, commit }, data) {
    if (state.isModalOpen === true) return;

    commit("SET_MODAL_DATA", data);
    commit("SET_MODAL_STATE", true);
  },

  setVideoModal({ state, commit }, data) {
    commit("SET_VIDEO_MODAL_STATE", data);
  },

  closeModal({ commit }) {
    commit("SET_MODAL_DATA", {});
    commit("SET_MODAL_STATE", false);
  }
};
